<template>

    <el-select v-model="selectedArray"
               :size="options.size"
               :multiple="options.multiple"
               :collapse-tags="options.collapseTags"
               :filterable="options.filterable"
               :clearable="options.clearable"
               :disabled="options.disabled"
               @change="change($event)"
               @remove-tag="removeTag">
        <el-option label="全部" value="全部" @click.native="selectAll"></el-option>
        <el-option v-for="item in deptInfoAllList" :label="item.name" :value="item.id"
                   :key="item.id"></el-option>
    </el-select>

</template>

<script>
    import CommonApi from "@/api/common";

    export default {
        name: "deptNew",

        props: {
            options: {
                type: Object,
                default: {
                    size: 'small',
                    multiple: true,
                    collapseTags: true,
                    filterable: true,
                    clearable: true,
                    disabled: false,
                }
            },
        },

        data() {
            return {
                deptIdsAll: [],
                deptInfoAllList: [],
                deptMap: new Map(),
                selectedArray: [],
            }
        },

        methods: {
            change: function (val) {
                if (!val.includes('全部') && val.length == this.deptInfoAllList.length) {
                    this.selectedArray.unshift('全部');
                } else if (val.includes('全部') && (val.length - 1) < this.deptInfoAllList.length) {
                    this.selectedArray = this.selectedArray.filter((item) => {
                        return item != '全部';
                    })
                }
                this.$emit('input', this.selectedArray);
                this.$emit('change', this.selectedArray);
            },

            selectAll() {
                if (this.selectedArray.length < this.deptInfoAllList.length) {
                    this.selectedArray = [];
                    this.deptInfoAllList.map((item) => {
                        this.selectedArray.push(item.id);
                    });
                    this.selectedArray.unshift('全部');
                } else {
                    this.selectedArray = [];
                }
                this.$emit('input', this.selectedArray);
                this.$emit('change', this.selectedArray);
            },

            removeTag(val) {
                if (val == '全部') {
                    this.selectedArray = [];
                }
                this.$emit('input', this.selectedArray);
                this.$emit('change', this.selectedArray);
            },
        },

        mounted() {
            CommonApi.getRunningDeptList().then(res => {
                this.deptInfoAllList = res;
                for (let i = 0; i < res.length; i++) {
                    this.deptIdsAll.push(res[i].id);
                    this.deptMap.set(res[i].id, res[i].name);
                }
                this.selectAll();
                this.$emit('fetchAllDepts', this.deptIdsAll);
            });
        },

    }
</script>

<style scoped>

</style>